import React from 'react';
import {useSelector} from "react-redux";

const CustomerInformation = ({}) => {
    const organisation = useSelector((state) => state.navigation.headerCustomerNumber);
    const customerNumber = useSelector((state) => state.navigation.headerOrganisation);
    
    return <>
        {organisation && customerNumber && (
            <>
                <p className="navbar__menu-header--organisation">{organisation}</p>
                <p>Customer: {customerNumber}</p>
            </>
        )}
    </>;
};

export default CustomerInformation;
